import { render, staticRenderFns } from "./doclog.vue?vue&type=template&id=997d06a0&scoped=true&"
import script from "./doclog.vue?vue&type=script&lang=js&"
export * from "./doclog.vue?vue&type=script&lang=js&"
import style0 from "./doclog.vue?vue&type=style&index=0&id=997d06a0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997d06a0",
  null
  
)

export default component.exports